import { IDateTimeFieldsMap } from './times.types'

export enum TimesConstants {
  NOT_IMPLEMENTED = 'times/NOT_IMPLEMENTED',
  SET_ONSET_TIME = 'times/SET_ONSET_TIME',
  SET_ONSET_DATE_TIME_PNNV = 'times/SET_ONSET_DATE_TIME_PNNV',
  SET_RECEIVED_TIME = 'times/SET_RECEIVED_TIME',
  SET_RECEIVED_DATE_TIME_PNNV = 'times/SET_RECEIVED_DATE_TIME_PNNV',
  SET_DISPATCH_NOTIFIED_TIME = 'times/SET_DISPATCH_NOTIFIED_TIME',
  SET_STANDBY_TIME = 'times/SET_STANDBY_TIME',
  SET_DISPATCHED_TIME = 'times/SET_DISPATCHED_TIME',
  SET_ACKNOWLEDGED_TIME = 'times/SET_ACKNOWLEDGED_TIME',
  SET_EN_ROUTE_TIME = 'times/SET_EN_ROUTE_TIME',
  SET_EN_ROUTE_DATE_TIME_PNNV = 'times/SET_EN_ROUTE_DATE_TIME_PNNV',
  SET_ONSET_DATE = 'times/SET_ONSET_DATE',
  SET_RECEIVED_DATE = 'times/SET_RECEIVED_DATE',
  SET_DISPATCH_NOTIFIED_DATE = 'times/SET_DISPATCH_NOTIFIED_DATE',
  SET_STANDBY_DATE = 'times/SET_STANDBY_DATE',
  SET_DISPATCHED_DATE = 'times/SET_DISPATCHED_DATE',
  SET_ACKNOWLEDGED_DATE = 'times/SET_ACKNOWLEDGED_DATE',
  SET_EN_ROUTE_DATE = 'times/SET_EN_ROUTE_DATE',
  ADD_ONSET_CURRENT_DATETIME = 'times/ADD_ONSET_CURRENT_DATETIME',
  ADD_RECEIVED_CURRENT_DATETIME = 'times/ADD_RECEIVED_CURRENT_DATETIME',
  ADD_DISPATCH_NOTIFIED_CURRENT_DATETIME = 'times/ADD_DISPATCH_NOTIFIED_CURRENT_DATETIME',
  ADD_STANDBY_CURRENT_DATETIME = 'times/ADD_STANDBY_CURRENT_DATETIME',
  ADD_DISPATCHED_CURRENT_DATETIME = 'times/ADD_DISPATCHED_CURRENT_DATETIME',
  ADD_ACKNOWLEDGED_CURRENT_DATETIME = 'times/ADD_ACKNOWLEDGED_CURRENT_DATETIME',
  ADD_EN_ROUTE_CURRENT_DATETIME = 'times/ADD_EN_ROUTE_CURRENT_DATETIME',
  SAVE_TIMES = 'times/SAVE_TIMES',
  SAVE_TIMES_RESPONSE = 'times/SAVE_TIMES_RESPONSE',
  SET_STAGING_TIME = 'times/SET_STAGING_TIME',
  SET_ON_SCENE_TIME = 'times/SET_ON_SCENE_TIME',
  SET_ON_SCENE_DATE_TIME_PNNV = 'times/SET_ON_SCENE_DATE_TIME_PNNV',
  SET_AT_PATIENT_TIME = 'times/SET_AT_PATIENT_TIME',
  SET_AT_PATIENT_DATE_TIME_PNNV = 'times/SET_AT_PATIENT_DATE_TIME_PNNV',
  SET_TRANSFER_CARE_EMS_TIME = 'times/SET_TRANSFER_CARE_EMS_TIME',
  SET_LEAVE_REFERRING_TIME = 'times/SET_LEAVE_REFERRING_TIME',
  SET_ARRIVE_RECEIVING_TIME = 'times/SET_ARRIVE_RECEIVING_TIME',
  SET_TRANSFER_CARE_EMS_DATE_TIME_PNNV = 'times/SET_TRANSFER_CARE_EMS_DATE_TIME_PNNV',
  SET_LEAVE_REFERRING_DATE_TIME_PNNV = 'times/SET_LEAVE_REFERRING_DATE_TIME_PNNV',
  SET_ARRIVE_RECEIVING_DATE_TIME_PNNV = 'times/SET_ARRIVE_RECEIVING_DATE_TIME_PNNV',
  SET_TRANSFER_CARE_DESTINATION_TIME = 'times/SET_TRANSFER_CARE_DESTINATION_TIME',
  SET_TRANSFER_CARE_DESTINATION_DATE_TIME_PNNV = 'times/SET_TRANSFER_CARE_DESTINATION_DATE_TIME_PNNV',
  SET_AVAILABLE_TIME = 'times/SET_AVAILABLE_TIME',
  SET_CALL_COMPLETED_TIME = 'times/SET_CALL_COMPLETED_TIME',
  SET_IN_QUARTERS_TIME = 'times/SET_IN_QUARTERS_TIME',
  SET_CANCELLED_TIME = 'times/SET_CANCELLED_TIME',
  SET_FIRST_RESPONDER_TIME = 'times/SET_FIRST_RESPONDER_TIME',
  SET_STAGING_DATE = 'times/SET_STAGING_DATE',
  SET_ON_SCENE_DATE = 'times/SET_ON_SCENE_DATE',
  SET_AT_PATIENT_DATE = 'times/SET_AT_PATIENT_DATE',
  SET_TRANSFER_CARE_EMS_DATE = 'times/SET_TRANSFER_CARE_EMS_DATE',
  SET_LEAVE_REFERRING_DATE = 'times/SET_LEAVE_REFERRING_DATE',
  SET_ARRIVE_RECEIVING_DATE = 'times/SET_ARRIVE_RECEIVING_DATE',
  SET_TRANSFER_CARE_DESTINATION_DATE = 'times/SET_TRANSFER_CARE_DESTINATION_DATE',
  SET_AVAILABLE_DATE = 'times/SET_AVAILABLE_DATE',
  SET_CALL_COMPLETED_DATE = 'times/SET_CALL_COMPLETED_DATE',
  SET_IN_QUARTERS_DATE = 'times/SET_IN_QUARTERS_DATE',
  SET_CANCELLED_DATE = 'times/SET_CANCELLED_DATE',
  SET_FIRST_RESPONDER_DATE = 'times/SET_FIRST_RESPONDER_DATE',
  ADD_STAGING_CURRENT_DATETIME = 'times/ADD_STAGING_CURRENT_DATETIME',
  ADD_ON_SCENE_CURRENT_DATETIME = 'times/ADD_ON_SCENE_CURRENT_DATETIME',
  ADD_AT_PATIENT_CURRENT_DATETIME = 'times/ADD_AT_PATIENT_CURRENT_DATETIME',
  ADD_TRANSFER_CARE_EMS_CURRENT_DATETIME = 'times/ADD_TRANSFER_CARE_EMS_CURRENT_DATETIME',
  ADD_LEAVE_REFERRING_CURRENT_DATETIME = 'times/ADD_LEAVE_REFERRING_CURRENT_DATETIME',
  ADD_ARRIVE_RECEIVING_CURRENT_DATETIME = 'times/ADD_ARRIVE_RECEIVING_CURRENT_DATETIME',
  ADD_TRANSFER_CARE_DESTINATION_CURRENT_DATETIME = 'times/ADD_TRANSFER_CARE_DESTINATION_CURRENT_DATETIME',
  ADD_AVAILABLE_CURRENT_DATETIME = 'times/ADD_AVAILABLE_CURRENT_DATETIME',
  ADD_CALL_COMPLETED_CURRENT_DATETIME = 'times/ADD_CALL_COMPLETED_CURRENT_DATETIME',
  ADD_IN_QUARTERS_CURRENT_DATETIME = 'times/ADD_IN_QUARTERS_CURRENT_DATETIME',
  ADD_CANCELLED_CURRENT_DATETIME = 'times/ADD_CANCELLED_CURRENT_DATETIME',
  ADD_FIRST_RESPONDER_DATETIME = 'times/ADD_FIRST_RESPONDER_DATETIME',
  RESET_TIMES_STATE = 'times/RESET_TIMES_STATE',
  GET_TIMES = 'times/GET_TIMES',
  SET_TIMES = 'times/SET_TIMES',
  RE_RUN_TIMES_VALIDATIONS = 'times/RE_RUN_TIMES_VALIDATIONS',
  SET_LEAVE_PATIENT_DATE = 'times/SET_LEAVE_PATIENT_DATE',
  SET_LEAVE_PATIENT_TIME = 'times/SET_LEAVE_PATIENT_TIME',
  ADD_LEAVE_PATIENT_CURRENT_DATETIME = 'times/ADD_LEAVE_PATIENT_CURRENT_DATETIME',
  SET_DESCENT_TIME = 'times/SET_DESCENT_TIME',
  SET_DESCENT_DATE = 'times/SET_DESCENT_DATE',
  ADD_DESCENT_CURRENT_DATETIME = 'times/ADD_DESCENT_CURRENT_DATETIME',
  SET_AT_LANDING_TIME = 'times/SET_AT_LANDING_TIME',
  SET_AT_LANDING_DATE = 'times/SET_AT_LANDING_DATE',
  ADD_AT_LANDING_CURRENT_DATETIME = 'times/ADD_AT_LANDING_CURRENT_DATETIME',
  SET_CUSTOM_1_DATETIME = 'times/SET_CUSTOM_1_DATETIME',
  SET_CUSTOM_1_DATE = 'times/SET_CUSTOM_1_DATE',
  SET_CUSTOM_1_TIME = 'times/SET_CUSTOM_1_TIME',
  SET_CUSTOM_2_DATETIME = 'times/SET_CUSTOM_2_DATETIME',
  SET_CUSTOM_2_DATE = 'times/SET_CUSTOM_2_DATE',
  SET_CUSTOM_2_TIME = 'times/SET_CUSTOM_2_TIME',
  SET_CUSTOM_3_DATETIME = 'times/SET_CUSTOM_3_DATETIME',
  SET_CUSTOM_3_DATE = 'times/SET_CUSTOM_3_DATE',
  SET_CUSTOM_3_TIME = 'times/SET_CUSTOM_3_TIME',
  SET_CUSTOM_4_DATETIME = 'times/SET_CUSTOM_4_DATETIME',
  SET_CUSTOM_4_DATE = 'times/SET_CUSTOM_4_DATE',
  SET_CUSTOM_4_TIME = 'times/SET_CUSTOM_4_TIME',
}

export const DateTimeFieldsMap: IDateTimeFieldsMap[] = [
  { fieldName: 'onset', configName: 'PR_DT_INJURY', disableConfigName: '' },
  { fieldName: 'received', configName: 'PR_DT_REC', disableConfigName: 'PR_DT_REC_DISABLE' },
  { fieldName: 'dispatchNotified', configName: 'PR_DT_NOTIFY', disableConfigName: 'PR_DT_NOTIFY_DISABLE' },
  { fieldName: 'standby', configName: 'PR_DT_STANDBY', disableConfigName: 'PR_DT_STANDBY_DISABLE' },
  { fieldName: 'acknowledged', configName: 'PR_DT_ACKNOWLEDGED', disableConfigName: 'PR_DT_ACKNOWLEDGED_DISABLE' },
  { fieldName: 'enRoute', configName: 'PR_DT_ENROUTE', disableConfigName: 'PR_DT_ENROUTE_DISABLE' },
  { fieldName: 'staging', configName: 'PR_DT_STAGING', disableConfigName: 'PR_DT_STAGING_DISABLE' },
  { fieldName: 'onScene', configName: 'PR_DT_ARRIVE', disableConfigName: 'PR_DT_ARRIVE_DISABLE' },
  { fieldName: 'atPatient', configName: 'PR_DT_ATPT', disableConfigName: '' },
  { fieldName: 'transferCareEMS', configName: 'PR_DT_TXCARE', disableConfigName: '' },
  { fieldName: 'leaveReferring', configName: 'PR_DT_LVREF', disableConfigName: 'PR_DT_LVREF_DISABLE' },
  { fieldName: 'arriveReceiving', configName: 'PR_DT_ARVREC', disableConfigName: 'PR_DT_ARVREC_DISABLE' },
  { fieldName: 'transferCareDestination', configName: 'PR_DT_TXCARE', disableConfigName: '' },
  { fieldName: 'callCompleted', configName: 'PR_DT_CALL_COMPLETED', disableConfigName: 'PR_DT_CALL_COMPLETED_DISABLE' },
  { fieldName: 'inQuarters', configName: 'PR_DT_INQTRS', disableConfigName: '' },
  { fieldName: 'cancelled', configName: 'PR_DT_CANCEL', disableConfigName: 'PR_DT_CANCEL_DISABLE' },
  { fieldName: 'firstResponder', configName: 'PR_DT_FRESP', disableConfigName: '' },
  { fieldName: 'leavePatient', configName: 'PR_DT_LVPT', disableConfigName: '' },
  { fieldName: 'custom1', configName: 'CUSTOM_TIME1', disableConfigName: 'PR_DT_CUSTOM_TIME1_DISABLE' },
  { fieldName: 'custom2', configName: 'CUSTOM_TIME2', disableConfigName: 'PR_DT_CUSTOM_TIME2_DISABLE' },
  { fieldName: 'custom3', configName: 'CUSTOM_TIME3', disableConfigName: 'PR_DT_CUSTOM_TIME3_DISABLE' },
  { fieldName: 'custom4', configName: 'CUSTOM_TIME4', disableConfigName: 'PR_DT_CUSTOM_TIME4_DISABLE' },
]

/* 
    Following constants represents service level / command fac level configs for each date time field.
    config value: 0 - Set default (current) date / time 
    config value: 1 - display field without default values
    config value: 2 - Hides the date / time field
    config value: 3 - Optional (only for command fac), fallback to the service level config

    disableValue (0 / 1) - Decides if a field is read only (disabled)

    DEFAULT_TIMES_UNUSED - Unset default values from all date/time fields
    */

export const DateTimeConfig = {
  SET_CURRENT_DATE_TIME_AS_DEFAULT: 0,
  DISPLAY_EMPTY_DATE_TIME: 1,
  HIDE_DATE_TIME: 2,
  USE_SERVICE_LEVEL_CONFIG: 3,
  UNSET_DEFAULT_VALUES: 1,
} as const
